<template>
    <div class="col-lg-8">
        <div class="big-underline-ttl">
            <h3>your payment method</h3>
            <div class="step-wrap">
                <div class="step step-2"></div>
            </div>
        </div>
        <div class="booking-box-block">
            <PaymentType
                :paymentTypes="paymentTypes"
                v-model="paymentType"
            ></PaymentType>

            <div class="mb-3">
                <PaymentCard
                    :isDisabled="isPayWithCash"
                    :order="order"
                    ref="paymentCard"
                ></PaymentCard>
            </div>

            <PaymentBilling
                :countries="input_countries"
                :isDisabled="isPayWithCash"
                :order="order"
                :states="input_states"
                ref="paymentBilling"
            ></PaymentBilling>
        </div>
    </div>
</template>

<script>
    import PaymentType from "./PaymentType";
    import PaymentCard from "./PaymentCard";
    import PaymentPaypal from "./PaymentPaypal";
    import PaymentBilling from "./PaymentBilling";
    import swalMessages from "../../../../../../resources/js/mixins/swal-messages";
    import { OrderService } from "@/js/services";

    export default {
        name: "PaymentMethod",
        mixins: [ swalMessages ],
        components: {
            PaymentBilling,
            PaymentCard,
            PaymentPaypal,
            PaymentType
        },
        props: {
            input_countries: {
                type: Array,
                required: true
            },
            input_states: {
                type: Array,
                required: true
            },
            order: {
                type: Object,
                required: true
            },
            boat: {
                type: Object
            },
        },
        data() {
            return {
                paymentTypes: [
                    {
                        id: 1,
                        value: 'credit_card',
                        text: 'Credit/Debit Card'
                    },
                    {
                        id: 2,
                        value: 'pay_with_cash',
                        text: 'Pay with cash',
                    },
                ],
                paymentType: 'pay_with_cash',
            }
        },
        computed: {
            isPayWithCash() {
                return this.paymentType === 'pay_with_cash'
            }
        },
        watch: {
            paymentType() {
                this.$refs.paymentBilling.$refs.form.reset();
                this.$refs.paymentCard.$refs.form.reset();
            }
        },
        methods: {
            resetAnimation() {
                this.$refs.paymentBilling.resetAnimation();
                this.$refs.paymentCard.resetAnimation();
            },
            validate() {
                this.resetAnimation();

                (async () => {
                    const list = [
                        {
                            name: 'Billing Information',
                            value: !this.isPayWithCash ? await this.$refs.paymentBilling.$refs.form.validate() : true
                        },
                        {
                            name: 'Card Information',
                            value: !this.isPayWithCash ? await this.$refs.paymentCard.$refs.form.validate() : true
                        },
                        {
                            name: 'Terms and Conditions',
                            value: await this.$refs.paymentBilling.$refs.agreement.validate()
                        },
                    ];

                    const valid = list.every(form => form.value);
                    const errors = list.filter(item => !item.value).map(item => item.name);

                    const { credit_card } = this.$refs.paymentCard;
                    const { billing } = this.$refs.paymentBilling;
                    const { agreement, ...billing_details } = billing;
                    const _token = $('meta[name="csrf-token"]').attr('content')

                    const payload = {
                        ...billing,
                        ...credit_card,
                        payment_details: credit_card,
                        payment_method: this.paymentType,
                        boat: this.boat,
                        _token,
                        billing_details
                    }

                    if (valid) {
                        await this.submit(payload);
                    } else {
                        this.showValidationErrorMessage(errors);
                    }

                })();
            },
            async submit(form) {
                this.showLoadingMessage();

                try {
                    await OrderService.submit(form);

                    this.showSuccessMessage('The order has been successfully created!');

                    setTimeout(() => {
                        location.href = '/order/review'
                    });
                } catch (e) {
                    this.showErrorMessage(e.response.statusText)

                    throw new Error(e);
                } finally {
                    setTimeout(() => {
                        this.$swal.close();
                    }, 2000)
                }
            }
        }
    }
</script>

<style scoped>
    .field-validation-error {
        color: #d54141;
        font-family: Open Sans, sans-serif;
        font-size: 13px;
        font-weight: 400;
        margin-bottom: 0;
    }

    .input-error {
        border: 2px solid #ffb996 !important;
        background-color: #fff8f6 !important;
        border-radius: 3px !important;
    }

    .label-error {
        color: #d54141 !important;
    }
</style>
